import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind class names with conflict resolution.
 * Consumer-provided classes come last so they win via tailwind-merge.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
